// extracted by mini-css-extract-plugin
export default {"img":"Oil_img__h9oO7"};